module.exports = __webpack_public_path__ + "static/yqhy_bg.fb865bb9.png";